import { format, eachDayOfInterval, lastDayOfMonth } from "date-fns";
import i18n from "@/i18n";

const {
  global: { t },
} = i18n;

export function isoToFullDateFormat(date: string): string {
  return format(date, "dd MMMM, yyyy");
}

export function isoToFullDateFormatFull(date: string): string {
  return format(date, "dd MMMM yyyy");
}

export function isoToFullDateFormatWithTimeFull(date: string): string {
  return format(date, "dd MMMM, HH:mm");
}

export function isoToShortDateFormat(date: string): string {
  return format(date, "dd MMMM");
}

export function isoToDefaultFormat(date: string): string {
  return format(date, "dd.MM.yyyy");
}

export function getCurrentMonth(): string {
  return format(new Date(), "LLLL");
}

export function getFormattedMonth() {
  t("months", format(new Date(), "L"));
}

export function formatDateToMonth(date: string): string {
  return format(date, "LLL");
}

export function getDatesInMonth() {
  const today = new Date();
  const firstDayMonth = format(today, "yyyy-MM-01");
  const lastDayMonth = format(lastDayOfMonth(today), "yyyy-MM-dd");

  return eachDayOfInterval({ start: firstDayMonth, end: lastDayMonth }).map(
    (day) => format(day, "d")
  );
}
